export const LOCATION_TREE_WILL_READ = 'LOCATION_TREE_WILL_READ';
export const LOCATION_TREE_READ_SUCCESS = 'LOCATION_TREE_READ_SUCCESS';
export const LOCATION_TREE_READ_PAGINATION_FINISHED = 'LOCATION_TREE_READ_PAGINATION_FINISHED';
export const LOCATION_TREE_READ_FAILED = 'LOCATION_TREE_READ_FAILED';

export const willReadLocationTree = (containerId, treeId) => ({
  type: LOCATION_TREE_WILL_READ,
  meta: {
    containerId,
    treeId
  }
});

export const readLocationTreeSuccess = payload => ({
  type: LOCATION_TREE_READ_SUCCESS,
  payload
});

export const readLocationTreePaginationFinished = () => ({
  type: LOCATION_TREE_READ_PAGINATION_FINISHED
});

export const readLocationTreeFailure = error => ({
  type: LOCATION_TREE_READ_FAILED,
  meta: {
    error
  }
});
